import { API_BASE, getApiHeaders } from '../config.js';
import type { CreateBattleResponse, JoinBattleResponse, MatchmakingResponse } from './protocol.js';
import type { MapDocument } from '@tank-battle/shared';

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || response.statusText);
  }
  if (response.status === 204) {
    return undefined as T;
  }
  return response.json() as Promise<T>;
}

export async function createBattle(mapId?: string): Promise<CreateBattleResponse> {
  const response = await fetch(`${API_BASE}/battles`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getApiHeaders() },
    body: JSON.stringify(mapId ? { mapId } : {}),
  });
  return parseJson(response);
}

export async function joinBattle(battleId: string): Promise<JoinBattleResponse> {
  const response = await fetch(`${API_BASE}/battles/${battleId}/join`, {
    method: 'POST',
    headers: getApiHeaders(),
  });
  return parseJson(response);
}

export async function joinMatchmaking(mapId?: string): Promise<MatchmakingResponse> {
  const response = await fetch(`${API_BASE}/matchmaking/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getApiHeaders() },
    body: JSON.stringify(mapId ? { mapId } : {}),
  });
  return parseJson(response);
}

export async function getMatchmakingStatus(): Promise<MatchmakingResponse> {
  const response = await fetch(`${API_BASE}/matchmaking/status`, {
    headers: getApiHeaders(),
  });
  return parseJson(response);
}

export async function leaveMatchmaking(): Promise<void> {
  const response = await fetch(`${API_BASE}/matchmaking/leave`, {
    method: 'DELETE',
    headers: getApiHeaders(),
  });
  await parseJson(response);
}

export async function fetchMap(mapId: string): Promise<MapDocument> {
  const response = await fetch(`${API_BASE}/maps/${mapId}`);
  return parseJson(response);
}
